import { IStuDoiTuongDaoTao } from "../../../model/respone/category/IStuDoiTuongDaoTao";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDoiTuongDaoTaoActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IStuDoiTuongDaoTao[],
  LOAD_ERRR: "",
};

export const eDoiTuongDaoTaoActionIds = generateActionTypeIds(eDoiTuongDaoTaoActionsObj, "DOI_TUONG_DAO_TAO");
export type IDoiTuongDaoTaoActionTypes = IGenericActionType<typeof eDoiTuongDaoTaoActionsObj, "DOI_TUONG_DAO_TAO">;
